import React from 'react'
import moment from 'moment'
import 'moment/locale/pt'

const renderBoxMessage = item => {
  if (item.show) {
    return (
      <div className='box' key={item.id}>
        <div>
          <blockquote>
            <i className="fas fa-quote-left" />
            {item.message}
            <i className="fas fa-quote-right" />
          </blockquote>
          <p><b>{item.name}</b> - {item.town.town}/{item.uf.uf}<span className='date'>{moment(item.time).format('LL')}</span></p>
        </div>
        <span className='heart'>♥</span>
      </div>
    )
  }

  return
}

const boxMessages = (props) => {
  const listItem = props.completeList
  return (
    <article>
      <div className='container'>
        {listItem.map(item => renderBoxMessage(item))}
      </div>
    </article>
  )
}

export default boxMessages




// WEBPACK FOOTER //
// ./src/components/BoxMessage.js